"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZUpload = void 0;
const kendo_react_upload_1 = require("@progress/kendo-react-upload");
const kendo_react_intl_1 = require("@progress/kendo-react-intl");
const ll_1 = require("../../languages/ll");
const react_1 = __importDefault(require("react"));
exports.ZUpload = (props) => {
    const { languageId } = react_1.default.useContext(ll_1.llContext);
    const uploadRef = react_1.default.useRef(null);
    kendo_react_intl_1.loadMessages({
        upload: {
            cancel: ll_1.ll({
                key: "Cancel",
                languageId: languageId
            }),
            clearSelectedFiles: ll_1.ll({
                key: "Clear",
                languageId: languageId
            }),
            dropFilesHere: ll_1.ll({
                key: "DropFilesHere",
                languageId: languageId
            }),
            headerStatusUploaded: ll_1.ll({
                key: "Done",
                languageId: languageId
            }),
            headerStatusUploading: ll_1.ll({
                key: "Uploading",
                languageId: languageId
            }),
            invalidFileExtension: ll_1.ll({
                key: "InvalidFileType",
                languageId: languageId
            }),
            invalidFiles: ll_1.ll({
                key: "InvalidFiles",
                languageId: languageId
            }),
            invalidMaxFileSize: ll_1.ll({
                key: "InvalidMaxFileSize",
                languageId: languageId
            }),
            invalidMinFileSize: ll_1.ll({
                key: "InvalidMinFileSize",
                languageId: languageId
            }),
            remove: ll_1.ll({
                key: "Remove",
                languageId: languageId
            }),
            retry: ll_1.ll({
                key: "Retry",
                languageId: languageId
            }),
            select: ll_1.ll({
                key: "SelectFile",
                languageId: languageId
            }),
            uploadSelectedFiles: ll_1.ll({
                key: "Upload",
                languageId: languageId
            }),
            total: ll_1.ll({
                key: "Total",
                languageId: languageId
            }),
            files: ll_1.ll({
                key: "Files",
                languageId: languageId
            }),
            statusUploadFailed: ll_1.ll({
                key: "FileUploadFailed",
                languageId: languageId
            }),
            statusUploaded: ll_1.ll({
                key: "FileUploadSuccess",
                languageId: languageId
            })
        }
    }, languageId);
    const handleDrop = (event) => {
        event.preventDefault();
    };
    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const handleDragLeave = () => { };
    return (react_1.default.createElement(kendo_react_intl_1.LocalizationProvider, { language: languageId },
        props.includeDropzone === true ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("style", null, `
                     .z-upload-dropzone-wrapper .k-external-dropzone .k-dropzone-inner {
                        display: flex !important;
                        flex-direction: column !important;
                        align-items: center !important;
                        justify-content: center !important;
                     }
                     .z-upload-dropzone-wrapper .k-external-dropzone .k-dropzone-inner .k-icon {
                        font-size: 40px !important;
                        margin-bottom: 8px;
                     }
                  `),
            react_1.default.createElement("div", { className: "z-upload-dropzone-wrapper", style: {
                    backgroundColor: "White",
                    position: "relative",
                    minHeight: "200px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                }, onDrop: handleDrop, onDragOver: handleDragOver, onDragLeave: handleDragLeave, tabIndex: 0, "aria-label": "File upload drop zone" },
                react_1.default.createElement(kendo_react_upload_1.ExternalDropZone, { uploadRef: uploadRef, style: { minHeight: "200px" } })))) : null,
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(kendo_react_upload_1.Upload, Object.assign({ batch: false, multiple: props.multiple || false, defaultFiles: [], autoUpload: false, showActionButtons: false, ref: uploadRef }, props)))));
};
//# sourceMappingURL=ZUpload.js.map